//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '~/api/index';
export default {
  name: 'HomeIndexData',
  filters: {
    netChangeFilter(str) {
      return (str * 100).toFixed(2) + '%';
    },
    shszFilter(str) {
      return (str / 100000000).toFixed(2);
    },
  },
  data() {
    return {
      dataList: [],
      timeInterval: null,
    };
  },

  beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  mounted() {
    this.timeInterval = setInterval(() => {
      this.getData();
    }, 30000);
    this.getData();
  },
  methods: {
    async getData() {
      try {
        const rsp = await this.$axios(api.getHomeData());
        this.dataList = rsp?.result || [];
      } catch (e) {
        console.error('api.getHomeData', e);
      }
    },
  },
};
